import React, { useEffect, useState } from "react";
import { Box, FormControl, FormControlLabel, RadioGroup } from "@mui/material";
import RadioButton from "../Common/RadioButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { StyledEngineProvider } from "@mui/material/styles";
import "./QuestionTypes.scss";
import { htmlParser } from "../../Utility/constants";
import TextInputQuestion from "./TextInputQuestion";

const SingleChoiceQuestion = (props) => {
  const {
    value,
    question,
    fieldConfig,
    onChange,
    qesType,
    errorIndicator,
    type,
    disabledField,
    renderDependentField,
  } = props;

  const [options, setOptions] = useState([]);

  const [selectedOption, setSelectedOption] = useState("");

  let flag = false;
  useEffect(() => {
    if (qesType && qesType === "y/n") {
      setOptions([
        { name: "Yes", val: "Yes", columnNo: 0 },
        { name: "No", val: "No", columnNo: 0 },
      ]);
    } else {
      const columns = [];
      let currentColumn = [];

      question.fieldValues.forEach((item, index) => {
        if (index === 0) {
          currentColumn.push(item);
          return;
        }

        if (item.newColumn) {
          columns.push(currentColumn);
          currentColumn = [];
        }

        currentColumn.push(item);
      });

      if (currentColumn.length > 0) {
        columns.push(currentColumn);
      }

      const optionsArray = columns.flatMap((group, columnIndex) =>
        group.map((item) => ({
          name: item.name,
          val: item.allowableValue,
          columnNo: columnIndex,
          dependentField: item.dependentField,
        }))
      );

      setOptions(optionsArray);
    }
  }, [qesType, question]);

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    onChange(value);
  };

  const handleRadioLabelDoubleClick = (option) => {
    if (selectedOption === option) {
      setSelectedOption("");
      onChange("");
    }
  };

  useEffect(() => {
    setSelectedOption(value);
  }, [value, question]);

  const groupedOptions = options.reduce((acc, option) => {
    const col = option.columnNo;
    if (!acc[col]) acc[col] = [];
    acc[col].push(option);
    return acc;
  }, {});

  const columnNos = Object.keys(groupedOptions)
    .map(Number)
    .sort((a, b) => a - b);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        paddingX: "15px",
      }}
    >
      <FormControl component="fieldset">
        <RadioGroup
          sx={{
            display: "flex",
            // flexDirection: question.fieldFlow === "NL" ? "column" : "row",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            flexWrap: "nowrap",
          }}
          value={selectedOption}
          onChange={handleRadioChange}
        >
          {columnNos?.map((col) => (
            <Box
              key={col}
              sx={{
                display: "flex",
                flexDirection:
                  qesType === "y/n"
                    ? question.fieldFlow === "NL"
                      ? "column"
                      : "row"
                    : "column",
              }}
            >
              {groupedOptions[col]?.map((option) => {
                return (
                  <Box
                    key={option.val}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex start",
                      marginRight: 1,
                    }}
                  >
                    <FormControlLabel
                      disabled={type === "preview" || disabledField}
                      control={
                        <RadioButton
                          disabledField={disabledField}
                          type={type}
                          flag={
                            (flag =
                              question?.historicalAnswer?.value === option.val
                                ? true
                                : false)
                          }
                        />
                      }
                      value={option.val}
                      label={
                        <>
                          {errorIndicator?.displayIndicator && (
                            <span style={{ color: "maroon" }}>{`<< `}</span>
                          )}
                          {flag ? (
                            <span style={{ color: "maroon" }}>
                              {htmlParser(option.name)}
                            </span>
                          ) : (
                            htmlParser(option.name)
                          )}
                        </>
                      }
                      onDoubleClick={() =>
                        handleRadioLabelDoubleClick(option.val)
                      }
                    />

                    {option.dependentField && renderDependentField?.()}
                  </Box>
                );
              })}
            </Box>
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default SingleChoiceQuestion;
